import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';
import {
  entityPersonasFisicaAddFailure,
  entityPersonasFisicaAddRequest,
  entityPersonasFisicaAddSuccess,
  entityPersonasFisicaChangeFailure,
  entityPersonasFisicaChangeRequest,
  entityPersonasFisicaChangeSuccess,
  entityPersonasFisicaLoadFailure,
  entityPersonasFisicaLoadRequest,
  entityPersonasFisicaLoadSuccess
} from './entity-personas-fisica.actions';

import { NotificationService } from '../../../core/core.module';
import { entityEntidadesProductivaAddSuccess } from '../entity-entidad-productiva/entity-entidades-productiva.actions';
import { entityRolAddSuccess } from '../../roles/entity-roles/entity-roles.actions';
import { PersonasFisicaService } from './entity-personas-fisica.service';

@Injectable()
export class PersonasFisicaEffects {
  // load
  loadRequestPersonasFisica = createEffect(() =>
    this.actions$.pipe(
      ofType(entityPersonasFisicaLoadRequest),
      mergeMap(() =>
        this.personasFisicaService.getPersonasFisica().pipe(
          map((items) => entityPersonasFisicaLoadSuccess({ items })),
          catchError((error) => of(entityPersonasFisicaLoadFailure({ error })))
        )
      )
    )
  );

  // add
  addRequestPersonasFisica = createEffect(() =>
    this.actions$.pipe(
      ofType(entityPersonasFisicaAddRequest),
      switchMap((action) =>
        this.personasFisicaService.addRPEPersonaFisica(action.item).pipe(
          map((item) => {
            return entityPersonasFisicaAddSuccess({
              item: { ...item, nombre_completo: action.item.nombre_completo }
            });
          }),
          catchError((error) =>
            of(entityPersonasFisicaAddFailure({ error: error.error }))
          )
        )
      )
    )
  );

  addSuccessPersonasFisica = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityPersonasFisicaAddSuccess),
        tap(() => {
          this.notificationService.success('Empresa registrada con éxito');
        })
      ),
    { dispatch: false }
  );

  addFailurePersonasFisica = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityPersonasFisicaAddFailure),
        tap((error) => {
          this.notificationService.error(error.error.errors[0].detail);
        })
      ),
    { dispatch: false }
  );

  //change

  changeRequestPersonaFisica = createEffect(() =>
    this.actions$.pipe(
      ofType(entityPersonasFisicaChangeRequest),
      switchMap((action) =>
        this.personasFisicaService.changeRPEPersonaFisica(action.item).pipe(
          map((item) =>
            entityPersonasFisicaChangeSuccess({
              item: {
                persona: item.persona_fisica,
                rol: item.rol,
                entidadProductiva: item.entidad_productiva
              }
            })
          ),
          catchError((error) => {
            return of(
              entityPersonasFisicaChangeFailure({ error: error.error })
            );
          })
        )
      )
    )
  );

  entityPersonasFisicaChangeSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityPersonasFisicaChangeSuccess),
        tap(() => {
          this.notificationService.success('Empresa modificada con éxito');
        })
      ),
    { dispatch: false }
  );

  // delete

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private personasFisicaService: PersonasFisicaService,
    private router: Router,
    private readonly notificationService: NotificationService
  ) {
    this.personasFisicaService.url = environment.apiUrl;
  }
}
